import FirmwareVersionPersTypes from 'store/actionTypes/firmwareVersionPers'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  system: []
}

const firmwareVersionPers = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case FirmwareVersionPersTypes.GET_LIST_FIRMWARE_VERSION_PERS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case FirmwareVersionPersTypes.GET_DETAIL_FIRMWARE_VERSION_PERS_SUCCESS:
      return {
        ...state,
        current: payload?.firmwareVersion
      }
    case FirmwareVersionPersTypes.GET_SYSTEM_FIRMWARE_VERSION_PERS_SUCCESS:
      return {
        ...state,
        system: payload?.items || []
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default firmwareVersionPers
